<div class="fg-topbar">

  <!-- Hamburger (mobile only) -->
  <div class="fg-hamburger" (click)="onToggleSidebar()">&#9776;</div>

  <!-- LOCAL / PREMISE SWITCHER -->
  <div class="ls-wrap" (click)="$event.stopPropagation()">
    <div class="ls-btn" [class.open]="lsOpen" (click)="toggleLocalSwitcher($event)">
      <div class="ls-dot"></div>
      <div class="ls-info">
        <div class="ls-empresa">{{ companyName || 'EL FOGÓN CHICKEN GRILL S.A.C.' }}</div>
        <!-- SADM no tiene local asignado, los demás sí -->
        <ng-container *ngIf="!isSysa">
          <div class="ls-local">&#128205; {{ activePremiseName || 'Seleccionar local' }}</div>
        </ng-container>
        <ng-container *ngIf="isSysa">
          <div class="ls-local">&#128736; Administrador de Plataforma</div>
        </ng-container>
      </div>
      <!-- Flecha sólo si el usuario tiene más de un local asignado
           (un MOZO con un único local no puede cambiar a otro). -->
      <span class="ls-arrow" *ngIf="!isSysa && (premises.length > 1 || idRole === 'ADMI')">&#9662;</span>
    </div>

    <!-- Dropdown: Premises -->
    <div class="ls-dropdown" *ngIf="lsOpen && !isSysa && premises.length > 0 && (premises.length > 1 || idRole === 'ADMI')">
      <div class="ls-dd-head">Locales</div>
      <div class="ls-dd-item" *ngFor="let p of premises" [class.active]="p.idPremise === activePremiseId"
        (click)="onSwitchPremise(p)">
        <div class="ls-dd-icon">🏢</div>
        <div>
          <div class="ls-dd-name">{{ p.description }}</div>
          <div class="ls-dd-dir" *ngIf="p.address">{{ p.address }}</div>
        </div>
        <span class="ls-dd-check" *ngIf="p.idPremise === activePremiseId">✅</span>
      </div>
      <!-- Administrar locales: sólo ADMI -->
      <ng-container *ngIf="idRole === 'ADMI'">
        <div class="ls-dd-sep"></div>
        <div class="ls-dd-footer" routerLink="/business/premises" (click)="lsOpen = false">&#9881;&#65039; Administrar
          locales</div>
      </ng-container>
    </div>

    <!-- Dropdown vacío: sólo ADMI ve el shortcut a administrar -->
    <div class="ls-dropdown" *ngIf="lsOpen && !isSysa && premises.length === 0 && idRole === 'ADMI'">
      <div class="ls-dd-head">No hay locales asignados</div>
      <div class="ls-dd-sep"></div>
      <div class="ls-dd-footer" routerLink="/business/premises" (click)="lsOpen = false">&#9881;&#65039; Administrar
        locales</div>
    </div>
  </div>

  <!-- Page title -->
  <div class="fg-tb-greeting">
    <span class="fg-tb-greet-text">{{ currentPageTitle }}</span>
  </div>

  <!-- Right side -->
  <div class="fg-tb-right">

    <!-- Clock -->
    <span class="fg-tb-clock">{{ currentTime | date: 'h:mm:ss a' }}</span>

    <!-- Dark mode toggle -->
    <div class="fg-dark-toggle" (click)="toggleDark()" title="Modo oscuro">
      {{ isDark ? '&#9728;' : '&#127769;' }}
    </div>

    <!-- Notifications -->
    <div class="fg-tb-icon">
      🔔
      <div class="fg-tb-notif-dot"></div>
    </div>

    <!-- Avatar + dropdown -->
    <div class="fg-tb-avatar-wrap" (click)="toggleProfileMenu(); $event.stopPropagation()">
      <div class="fg-tb-avatar">{{ userInitial }}</div>
      <div class="fg-tb-role">{{ roleLabel }}</div>

      <!-- Profile dropdown -->
      <div class="fg-tb-dropdown" *ngIf="profileMenuOpen">
        <div class="fg-tb-dd-head">
          <div class="fg-tb-dd-name">{{ Usuario.name }} {{ Usuario.lastName }}</div>
          <div class="fg-tb-dd-user">{{ Usuario.userName }}</div>
        </div>
        <div class="fg-tb-dd-sep"></div>
        <div class="fg-tb-dd-item" (click)="onLogout($event)">
          &#128682; Cerrar Sesión
        </div>
      </div>
    </div>

  </div>
</div>